import { LoaderFunctionArgs, MetaFunction } from "react-router";
import { Link, useLoaderData, useLocation } from "react-router";
import { useTranslation } from "react-i18next";

import { calculators, categories } from "~/catalog";
import H1 from "~/components/H1";
import H2 from "~/components/H2";
import ToolPlate from "~/components/ToolPlate";
import { makeTitle } from "~/helpers/pageTitle";
import { getLocale } from "~/i18n";
import { getTranslator } from "~/i18next.server";


export const meta: MetaFunction<typeof loader> = ({ data }) => [
  { title: makeTitle(data?.title) },
  { name: "description", content: data?.description }
];

export const handle = {
  localisedLinks: ["en", "ru", "de", "fr", "es", "it", "pt"]
};

export const loader = async ({ request }: LoaderFunctionArgs) => {
  const t = await getTranslator(request);

  // This will ensure that invalid locales do not render page
  if (getLocale(request.url) === null) {
    throw new Response(null, { status: 404 });
  }

  return {
    title: t("catalog.title"),
    description: t("catalog.description")
  };
};


export default function Index() {
  const data = useLoaderData<typeof loader>();

  const { t } = useTranslation("translations");

  const locale = getLocale(useLocation().pathname) ?? '';

  return (
    <main>
      <section className="py-10 max-w-[800px] mx-auto text-center">
        <H1 className="md:text-5xl">{data.title}</H1>
        <p className="py-6 mb-10 md:text-xl">{data.description}</p>
      </section>

      <div className="flex flex-col gap-10 mb-6">
        {categories.map((category) => (category.locales === undefined || category.locales.includes(locale)) ? (
          <div
            key={category.id}
            className="flex flex-col gap-4 py-6"
          >
            <H2>
              <Link to={`/${locale}/${category.id}`} className="border-0">
                {t(`catalog.categories.${category.id}`)}
              </Link>
            </H2>
            <div
              className="pt-6 grid gap-4 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3"
            >
              {calculators.map((calculator) =>
                calculator.category === category.id
                && (calculator.locales === undefined || calculator.locales.includes(locale))
                && (calculator.excludedLocales === undefined || !calculator.excludedLocales.includes(locale))
                  ? (
                    <ToolPlate
                      key={calculator.id}
                      title={t(`calculators.${category.id}.${calculator.id}.title`)}
                      description={t(`calculators.${category.id}.${calculator.id}.description`)}
                      link={`/${locale}/${calculator.slug}`}
                    />
                  ) : null)
              }
            </div>
            </div>
            ) : null)}
          </div>
          </main>
          );
        }
